import { forwardRef } from 'react';

import { type LBIcon } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

type RoundButtonProps = {
  icon?: LBIcon;
  count?: number;
  active?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const RoundButton = forwardRef<HTMLButtonElement, RoundButtonProps>(
  ({ icon: Icon, count = 0, active, className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        'inline-flex h-9 shrink-0 items-center gap-2 whitespace-nowrap rounded-full border px-4 text-sm',
        'text-foreground hover:bg-surface-hover data-[state=open]:bg-surface-hover',
        'focus-ring transition-colors disabled:pointer-events-none disabled:opacity-50',
        (Icon || count > 0) && 'pl-3.5',
        active ? 'border-border-strong bg-surface-active' : 'border-border',
        className
      )}
      {...props}
    >
      {count > 0 ? (
        <span
          aria-hidden
          className="flex size-4 shrink-0 items-center justify-center rounded-full bg-foreground text-[0.625rem] font-medium tabular-nums text-background"
        >
          {count}
        </span>
      ) : (
        Icon && <Icon className="size-4 shrink-0 text-foreground-muted" />
      )}
      {children}
    </button>
  )
);
RoundButton.displayName = 'RoundButton';
